import React, {useContext} from "react";
import NVHorizontalBarChart, {
  formats,
} from "common/graphs/NVHorizontalBarChart";
import styled from "styled-components";
import BqnContext from "common/BqnContext";

const UsageGraphLayout = styled.div`
  h4 {
    text-align: center;
    &.align-left {
      text-align: left;
    }
  }
  .centered {
    text-align: center;
  }
`;

const getFilteredResult = (result, bqnId, mode) => {
  if (!result || bqnId === "all" || mode === "standalone") {
    return result;
  }
  return Object.entries({ ...result }).reduce((acc, [key, value]) => {
    const filteredValue = Array.isArray(value)
      ? value.filter((item) => {
          return item.bqnId === bqnId.toString();
        })
      : value;
    acc[key] = filteredValue;
    return acc;
  }, {});
};

const Result = ({data}) => {
  const {
    bqnId,
    clusterStatus: { mode },
  } = useContext(BqnContext);
  const filteredResult = getFilteredResult(data, bqnId, mode);
  const barColor = "#006AB7";

  const sortedUsage = filteredResult.usage
    .slice()
    .sort((a, b) => parseFloat(a.bqnId) - parseFloat(b.bqnId));
  
  return (
    <UsageGraphLayout>
      <h4>Root disk partition</h4>
      <NVHorizontalBarChart
        key={`horizontal-bar-chart-${bqnId}`}
        valueUnits=""
        tooltipValueFormatter={(value) => `${formats.oneDecimal(value)} GB`}
        items={[
          {
            key: "Used",
            color: barColor,
            values: sortedUsage.map((item) => ({
                label: item.bqnId === undefined ? "" : `BQN ${item.bqnId}`,
                value: item.used,
              })),
          },
          {
            key: "Free",
            color: `${login.isTheme("light") ? "#cacaca" : "#3A3A3E"}`,
            values: sortedUsage.map((item) => ({
                label: item.bqnId === undefined ? "" : `BQN ${item.bqnId}`,
                value: item.free,
              })),
          },
        ]}
        showRoundCorners={true}
        showColors={true}
        barHeight={45}
      />
      <div className="centered">Gbytes</div>
    </UsageGraphLayout>
  );
};

export default Result;
